function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1900(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 31.08,
    height: 12.06,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.54,
    y: 6.03
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 12.06,
    width: 31.08,
    height: 36.97,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.54,
    y: 30.545
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 49.03,
    width: 31.08,
    height: 47.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.885
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.54,
    y: 72.885
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 96.74,
    width: 31.08,
    height: 59.26,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.215999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.54,
    y: 126.36999999999999
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 156,
    width: 31.08,
    height: 73.34,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.215999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.54,
    y: 192.67000000000002
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 229.33,
    width: 31.08,
    height: 73.95,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.215999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.54,
    y: 266.305
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 303.28,
    width: 31.08,
    height: 75.34,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.54,
    y: 340.95
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 378.62,
    width: 31.08,
    height: 77.49,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.54,
    y: 417.365
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 456.11,
    width: 31.08,
    height: 80.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.4399999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.54,
    y: 496.285
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 536.47,
    width: 31.08,
    height: 81.73,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.885
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.54,
    y: 577.335
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 618.19,
    width: 31.08,
    height: 81.81,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.215999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.54,
    y: 659.095
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.08,
    y: 0,
    width: 48.32,
    height: 53.37,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.239999999999995,
    y: 26.685
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.41,
    y: 0,
    width: 49.48,
    height: 53.37,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.0685714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 104.14999999999999,
    y: 26.685
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.89,
    y: 0,
    width: 49.5,
    height: 53.37,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.1875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 153.64,
    y: 26.685
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.39,
    y: 0,
    width: 49.56,
    height: 53.37,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.506666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 203.17,
    y: 26.685
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.95,
    y: 0,
    width: 52.85,
    height: 53.37,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.808333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 254.375,
    y: 26.685
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.81,
    y: 0,
    width: 53.39,
    height: 53.37,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.624285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 307.505,
    y: 26.685
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 334.2,
    y: 0,
    width: 54.66,
    height: 53.37,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.67125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 361.53,
    y: 26.685
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 388.86,
    y: 0,
    width: 57.5,
    height: 53.37,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.67125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 417.61,
    y: 26.685
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 446.36,
    y: 0,
    width: 58.64,
    height: 53.37,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.337
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 475.68,
    y: 26.685
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 505,
    y: 0,
    width: 63.79,
    height: 53.37,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.624285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 536.895,
    y: 26.685
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 568.79,
    y: 0,
    width: 64.07,
    height: 53.37,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.67125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 600.8249999999999,
    y: 26.685
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 632.86,
    y: 0,
    width: 67.14,
    height: 53.37,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.624285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 666.4300000000001,
    y: 26.685
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.08,
    y: 53.37,
    width: 59.6,
    height: 60.86,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.933333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.879999999999995,
    y: 83.8
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.08,
    y: 114.23,
    width: 59.6,
    height: 61.62,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.45
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.879999999999995,
    y: 145.04
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.08,
    y: 175.84,
    width: 59.6,
    height: 61.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.45
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.879999999999995,
    y: 206.77
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.08,
    y: 237.7,
    width: 59.6,
    height: 62.02,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.933333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.879999999999995,
    y: 268.71
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.08,
    y: 299.72,
    width: 59.6,
    height: 63.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.418181818181818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.879999999999995,
    y: 331.54
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.08,
    y: 363.36,
    width: 59.6,
    height: 63.79,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.96
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.879999999999995,
    y: 395.255
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.08,
    y: 427.15,
    width: 59.6,
    height: 67.32,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.45
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.879999999999995,
    y: 460.80999999999995
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.08,
    y: 494.46,
    width: 59.6,
    height: 67.61,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.96
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.879999999999995,
    y: 528.265
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.08,
    y: 562.08,
    width: 59.6,
    height: 67.82,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.879999999999995,
    y: 595.99
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.08,
    y: 629.9,
    width: 59.6,
    height: 70.1,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.45
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.879999999999995,
    y: 664.9499999999999
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.69,
    y: 53.37,
    width: 59.59,
    height: 72.5,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.512857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.485,
    y: 89.62
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150.28,
    y: 53.37,
    width: 61.11,
    height: 72.5,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.73
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 180.835,
    y: 89.62
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.39,
    y: 53.37,
    width: 61.22,
    height: 72.5,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.6525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 242,
    y: 89.62
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 272.61,
    y: 53.37,
    width: 62.84,
    height: 72.5,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.473333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 304.03000000000003,
    y: 89.62
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.45,
    y: 53.37,
    width: 69.46,
    height: 72.5,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.922857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.18,
    y: 89.62
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 404.91,
    y: 53.37,
    width: 70.11,
    height: 72.5,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.76375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 439.96500000000003,
    y: 89.62
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 475.02,
    y: 53.37,
    width: 72.97,
    height: 72.5,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.590909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 511.505,
    y: 89.62
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 547.99,
    y: 53.37,
    width: 75.17,
    height: 72.5,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.083333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 585.575,
    y: 89.62
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 623.16,
    y: 53.37,
    width: 76.84,
    height: 72.5,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.357142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 661.5799999999999,
    y: 89.62
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.69,
    y: 125.87,
    width: 77.72,
    height: 73,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.166666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.55,
    y: 162.37
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.69,
    y: 198.87,
    width: 77.72,
    height: 75.19,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.531666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.55,
    y: 236.465
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.69,
    y: 274.07,
    width: 77.72,
    height: 79.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.635555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.55,
    y: 313.675
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.69,
    y: 353.28,
    width: 77.72,
    height: 81.85,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.55,
    y: 394.205
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.69,
    y: 435.13,
    width: 77.72,
    height: 86.1,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.953333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.55,
    y: 478.18
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.69,
    y: 521.23,
    width: 77.72,
    height: 87.72,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.476666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.55,
    y: 565.09
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.69,
    y: 608.94,
    width: 77.72,
    height: 91.06,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.102857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.55,
    y: 654.47
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.41,
    y: 125.87,
    width: 86.07,
    height: 83.3,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.33
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 211.445,
    y: 167.52
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 254.48,
    y: 125.87,
    width: 94.04,
    height: 83.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.883333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 301.5,
    y: 167.52
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 348.52,
    y: 125.87,
    width: 106.57,
    height: 83.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.883333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 401.80499999999995,
    y: 167.52
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 455.08,
    y: 125.87,
    width: 118.95,
    height: 83.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.33
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 514.555,
    y: 167.52
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 574.03,
    y: 125.87,
    width: 125.97,
    height: 83.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.883333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 637.015,
    y: 167.52
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.41,
    y: 209.17,
    width: 110.5,
    height: 111.07,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.045454545454545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 223.66,
    y: 264.705
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.41,
    y: 320.24,
    width: 110.5,
    height: 117.32,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.8125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 223.66,
    y: 378.9
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.41,
    y: 437.56,
    width: 110.5,
    height: 122.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.416666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 223.66,
    y: 498.79
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.41,
    y: 560.02,
    width: 110.5,
    height: 139.98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.416666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 223.66,
    y: 630.01
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.91,
    y: 209.17,
    width: 119.05,
    height: 230.39,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 29.7625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 338.435,
    y: 324.365
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 397.96,
    y: 209.17,
    width: 302.04,
    height: 230.39,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 46.077999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 548.98,
    y: 324.365
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.91,
    y: 439.56,
    width: 421.09,
    height: 260.44,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 32.555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 489.45500000000004,
    y: 569.78
  }, "\n        New_York\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1900);
export default __webpack_public_path__ + "static/media/1900.5bb66df318a298be2b32bbb50384cb0f.svg";
export { ForwardRef as ReactComponent };